import React from "react";
import StudentsupportSection from "../../components/StudentWorld/Studentsupport.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const StudentSupport: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="Student’s Support | Aptech Limited."
        desc="Aptech offers financial aid for deserving students! Explore scholarships, low-cost EMIs, and hassle-free student loans. Empower your future today."
        keywords="financial assistance at aptech, aptech education loans, low-cost EMI for education loans."
      />
      
      <StudentsupportSection />
    </div>
  );
};

export default StudentSupport;
